<template>
  <modal ref='modal'>
    <template #header>
      <h5 class="modal-title mt-0">
        {{ $t('move_attachments_modal.title') }}
      </h5>
    </template>

    <template #body>
      <div class='modal-body'>
        {{ $t('move_attachments_modal.body') }}
        <single-select :options='folders' v-model='folder' />
      </div>

      <div class='modal-footer'>
        <a @click.prevent='deleteAttachments' href='#' class='btn btn-neutral'>
          {{ $t('move_attachments_modal.dont_save') }}
        </a>

        <a @click.prevent='moveAttachments' href='#' :class="[{ disabled: !folder.id }, 'btn btn-primary']">
          {{ $t('move_attachments_modal.save') }}
        </a>
      </div>
    </template>
  </modal>
</template>

<script>
  import _modal from './_modal'
  import _single_select from './shared/_single_select'

  export default {
    components: {
      'modal': _modal,
      'single-select': _single_select,
    },
    data() {
      return {
        folder: {},
        records: [],
      }
    },
    computed: {
      folders() {
        return this.lists.folders || []
      },
      recordIds() {
        return this.records.map(r => r.id)
      },
    },
    methods: {
      open(records) {
        this.folder = {}
        this.records = records

        this.listStore.getFolders()

        this.$refs.modal.open()
      },
      close() {
        this.$refs.modal.close()
      },
      moveAttachments() {
        if (this.folder.id) {
          this.store.bulkMoveRecords({ record_ids: this.recordIds, folder_id: this.folder.id })
          this.$toastr.success(this.$t('move_attachments_modal.moving'))
        }

        this.close()
      },
      deleteAttachments() {
        this.store.bulkDeleteRecords({ ids: this.recordIds })

        this.$toastr.success(this.$t('move_attachments_modal.deleting'))

        this.close()
      },
    }
  }
</script>
